import { render, staticRenderFns } from "./ImportPage.vue?vue&type=template&id=09249106&scoped=true&"
import script from "./ImportPage.vue?vue&type=script&lang=js&"
export * from "./ImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09249106",
  null
  
)

export default component.exports